import React, { useEffect, useState } from "react"
import PropTypes from "prop-types"
import fallbackLogo from "../../images/logo.png"
import CardImage from "../CardImage/CardImage"

const RemoteArticleImage = ({
  src,
  className,
  alt = "",
  variant = "card",
  forceFit,
}) => {
  const [current, setCurrent] = useState(src || fallbackLogo)
  const isFallback = !src || current === fallbackLogo

  useEffect(() => {
    setCurrent(src || fallbackLogo)
  }, [src])

  return (
    <CardImage
      src={current}
      alt={alt}
      className={className}
      variant={variant}
      forceFit={isFallback ? "logo" : forceFit}
      onError={() => {
        if (current !== fallbackLogo) {
          setCurrent(fallbackLogo)
        }
      }}
    />
  )
}

RemoteArticleImage.propTypes = {
  src: PropTypes.string,
  className: PropTypes.string,
  alt: PropTypes.string,
  variant: PropTypes.oneOf(["card", "detail"]),
  forceFit: PropTypes.oneOf(["cover", "contain", "banner", "logo"]),
}

export default RemoteArticleImage
